// Ubicación de postulantes y promotores (ciudad + distrito). La ciudad nace
// en Lima: es donde ocurre la mayoría de campañas (ver FAQ de /postular).

export const CIUDAD_PREDETERMINADA = "Lima";
export const MAX_LARGO_UBICACION = 80;

/**
 * Ciudades del Perú para el desplegable (capitales de departamento y ciudades
 * principales). Lima va primero; el resto, en orden alfabético. Si un valor
 * guardado antes como texto libre no está aquí, la UI lo conserva como opción.
 */
export const CIUDADES_PERU = [
  "Lima",
  "Callao",
  "Abancay",
  "Andahuaylas",
  "Arequipa",
  "Ayacucho",
  "Barranca",
  "Cajamarca",
  "Cañete",
  "Cerro de Pasco",
  "Chachapoyas",
  "Chepén",
  "Chiclayo",
  "Chimbote",
  "Chincha Alta",
  "Chulucanas",
  "Cusco",
  "Ferreñafe",
  "Huacho",
  "Huancavelica",
  "Huancayo",
  "Huánuco",
  "Huaral",
  "Huaraz",
  "Ica",
  "Ilo",
  "Iquitos",
  "Jaén",
  "Jauja",
  "Juanjuí",
  "Juliaca",
  "La Merced",
  "Lambayeque",
  "Mala",
  "Moquegua",
  "Moyobamba",
  "Nazca",
  "Oxapampa",
  "Paita",
  "Pisco",
  "Piura",
  "Pucallpa",
  "Puerto Maldonado",
  "Puno",
  "Quillabamba",
  "Rioja",
  "Sechura",
  "Sullana",
  "Tacna",
  "Talara",
  "Tarapoto",
  "Tarma",
  "Tingo María",
  "Trujillo",
  "Tumbes",
  "Yurimaguas",
] as const;

/** Distritos de Lima Metropolitana y del Callao, para sugerir en el formulario. */
export const DISTRITOS_LIMA = [
  "Ancón",
  "Ate",
  "Barranco",
  "Breña",
  "Carabayllo",
  "Chaclacayo",
  "Chorrillos",
  "Cieneguilla",
  "Comas",
  "El Agustino",
  "Independencia",
  "Jesús María",
  "La Molina",
  "La Victoria",
  "Lima (Cercado)",
  "Lince",
  "Los Olivos",
  "Lurigancho-Chosica",
  "Lurín",
  "Magdalena del Mar",
  "Miraflores",
  "Pachacámac",
  "Pucusana",
  "Pueblo Libre",
  "Puente Piedra",
  "Punta Hermosa",
  "Punta Negra",
  "Rímac",
  "San Bartolo",
  "San Borja",
  "San Isidro",
  "San Juan de Lurigancho",
  "San Juan de Miraflores",
  "San Luis",
  "San Martín de Porres",
  "San Miguel",
  "Santa Anita",
  "Santa María del Mar",
  "Santa Rosa",
  "Santiago de Surco",
  "Surquillo",
  "Villa El Salvador",
  "Villa María del Triunfo",
  "Callao",
  "Bellavista",
  "Carmen de la Legua-Reynoso",
  "La Perla",
  "La Punta",
  "Mi Perú",
  "Ventanilla",
] as const;

/**
 * Minúsculas y sin tildes, igual que la columna espejo `distrito_search`
 * (trigger con unaccent en la base). Ojo: NFD también separa la virgulilla de
 * la «ñ»; unaccent la convierte en «n», así que el resultado coincide.
 */
export function normalizarParaBusqueda(texto: string): string {
  return texto.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase().trim();
}

/** "Distrito, Ciudad" o solo la ciudad; null si no hay nada que mostrar. */
export function formatearUbicacion(
  ciudad: string | null | undefined,
  distrito: string | null | undefined,
): string | null {
  const partes = [distrito?.trim(), ciudad?.trim()].filter(Boolean);
  return partes.length > 0 ? partes.join(", ") : null;
}
